import { PackageAttributes } from '@/types'
import { UpdatePackageMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditPackageQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'

type Package = EditPackageQuery['packages']['nodes'][0]

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading
  } = useForm<UpdatePackageMutation, PackageAttributes, EditPackageQuery, Package>({
    id,
    initializer: pakage => ({
      availableToEvents: pakage.availableToEvents || false,
      displayOnWebsite: pakage.displayOnWebsite || false,
      description: pakage.description || '',
      name: pakage.name,
      rateCents: pakage.rateCents || 0,
    }),
    query: EditQuery,
    queryKey: 'packages',
    mutation: UpdateMutation,
    resultKey: 'updatePackage'
  })

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        <div className="grid grid-cols-2 gap-6">
          { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
          { formBuilder.buildField({ name: 'Rate', field: 'rateCents', type: 'currency' }) }
        </div>
        <div className="grid grid-cols-2 gap-6">
          { formBuilder.buildField({ name: 'Display on your website', field: 'displayOnWebsite', type: 'switch' }) }
          { formBuilder.buildField({ name: 'Available to events', field: 'availableToEvents', type: 'switch' }) }
        </div>
        { formBuilder.buildField({ name: 'Description', field: 'description', type: 'text' }) }

        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
